import { createAction, props } from '@ngrx/store';
import { ICreateStatus, IEditStatusPayloadModel, IStatus } from '../models/statuses.model';

export const GetStatusesList = createAction('[Statuses] Get Statuses list');
export const GetStatusesListSuccess = createAction(
  '[Statuses] Get Statuses list success',
  props<{ payload: { statuses: IStatus[] } }>()
);
export const GetStatusesListFailed = createAction('[Statuses] Get Statuses list error', props<{ payload: Error }>());

export const CreateStatus = createAction('[Statuses] Create status', props<{ payload: ICreateStatus }>());
export const CreateStatusSuccess = createAction('[Statuses] Create status success', props<{ payload: IStatus }>());
export const CreateStatusFailed = createAction('[Statuses] Create status error', props<{ payload: Error }>());

export const EditStatus = createAction('[Statuses] Edit status', props<{ payload: IEditStatusPayloadModel }>());
export const EditStatusSuccess = createAction('[Statuses] Edit status success', props<{ payload: IStatus }>());
export const EditStatusFailed = createAction('[Statuses] Edit status error', props<{ payload: Error }>());

export const DeleteStatus = createAction('[Statuses] Delete status', props<{ payload: string }>());
export const DeleteStatusSuccess = createAction('[Statuses] Delete status success', props<{ payload: string }>());
export const DeleteStatusFailed = createAction('[Statuses] Delete status error', props<{ payload: Error }>());
